import { useTranslation } from "react-i18next";

export const FormFooter = (props: any) => {
    const { t } = useTranslation();
    return <>
        <div style={{ marginTop: "35px" }}>
            <input
                type="submit"
                disabled={props.isSubmitting || props.isValidating}
                className="btn btn-primary btn-block"
                value={t("SubmitButton", "Soumettre") ?? "Soumettre"} />
        </div>
    </>;
}